<template lang="pug">
.base.mb-4.mt-4
  .form-check.me-3(v-if='enableGeneratePDFA')
    input#flexCheckDefault.form-check-input(
      :checked='typePDFA'
      @change='$emit("generatePDFA", $event.target.checked)'
      type='checkbox'
    )
    label.form-check-label(for='flexCheckDefault') Gerar PDF/A
    span.help.px-2(v-tooltip:right='tooltipPDFA')
      icon.fs-6(name='circle-question')
  .form-check.me-3(v-if='enableSaveTemplate')
    input#flexCheckDefault.form-check-input(
      @change='processSaveTemplate($event)'
      type='checkbox'
    )
    label.form-check-label(for='flexCheckDefault') {{ $t('modal.envelope.saveAsTemplate') }}
  .me-3
    button.btn.btn-thin.btn-thin--envelope-bottom(@click='processClose')
      span.text {{ getCloseButtonLabel }}
  .me-3(v-if='showSubmitToReviewButton')
    button.btn.btn-thin(
      :class='{ disabled: disabledSubmitReview }'
      :disabled='disabledSubmitReview'
      @click='processSubmitToReview'
    )
      span.text {{ $t('modal.envelope.submitToReview') }}
  div
    button.btn.btn-primary(
      :disabled='disableButtonNextStep'
      :hidden='hiddenButtonNextStep || isSaveTemplatePage'
      @click='nextStep'
    )
      span.text {{ textButtonNextStep || $t('modal.envelope.next') }}
  .dropdown-stylized.envelope-action-dropdown(
    :hidden='!showDropdownButtonNextStep'
  )
    button.btn.btn-primary(
      aria-expanded='false'
      data-bs-toggle='dropdown'
      type='button'
    )
      span.text {{ textButtonNextStep || $t('modal.envelope.next') }}
      icon.arrow(name='angle-down')
    .dropdown-menu
      ul
        li
          button.dropdown-item(
            :class='{ disabled: disabledSend }'
            :disabled='disabledSend'
            @click='$emit("send", $event)'
            type='button'
          )
            .text {{ $t('modal.envelope.send') }}
        li
          button.dropdown-item(
            :class='{ disabled: disabledSubmitReview }'
            :disabled='disabledSubmitReview'
            @click='$emit("submitToReview", $event)'
            type='button'
          )
            .text {{ $t('modal.envelope.submitToReview') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'EnvelopeBottom',
  components: {
    Icon,
  },
  props: {
    enableGeneratePDFA: {
      type: Boolean,
      default: false,
    },
    typePDFA: {
      type: Boolean,
      default: false,
    },
    enableSaveTemplate: {
      type: Boolean,
      default: false,
    },
    textButtonNextStep: {
      type: String,
      default: '',
    },
    disableButtonNextStep: {
      type: Boolean,
      default: false,
    },
    isSaveTemplatePage: {
      type: Boolean,
      default: false,
    },
    discardAndClose: {
      type: Boolean,
      default: false,
    },
    hiddenButtonNextStep: {
      type: Boolean,
      default: false,
    },
    showDropdownButtonNextStep: {
      type: Boolean,
      default: false,
    },
    disableDropdownButtonNextStep: {
      type: Boolean,
      default: false,
    },
    disabledSend: {
      type: Boolean,
      default: false,
    },
    disabledSubmitReview: {
      type: Boolean,
      default: false,
    },
    showSubmitToReviewButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipPDFA:
        'PDF/A é um formato de arquivo padronizado para preservar documentos digitais a longo prazo.\
        <br>Ao ativar essa opção a configuração de campos nos documentos será\
        limitada para atender aos requisitos do PDF/A.',
    };
  },
  computed: {
    getCloseButtonLabel() {
      return this.discardAndClose
        ? this.$t('modal.envelope.discardAndClose')
        : this.$t('modal.envelope.saveAndClose');
    },
  },
  methods: {
    processSaveTemplate(event) {
      this.$emit('save-template', event.target.checked);
    },
    processClose() {
      if (this.discardAndClose) {
        this.$emit('discardAndClose');
      } else {
        this.$emit('saveAndClose');
      }
    },
    processSubmitToReview() {
      this.$emit('openSubimitToReview');
    },
    nextStep() {
      this.$emit('nextStep');
    },
  },
};
</script>
<style lang="stylus">
.base
  height: 70px
  display: flex
  vertical-align: middle
  flex-direction: row
  width: inherit
  align-items: center
  justify-content: flex-end
  .envelope-action-dropdown
    > button.btn-primary
      display: inline-flex
      align-items: center
      justify-content: center
      border-radius: 10px
      min-height: 44px
      padding: 0.625rem 1rem
      box-sizing: border-box
      > .text
        color: inherit
        font-weight: 600
      > .icon.arrow
        color: inherit
        margin: auto 0.875rem !important
        height: auto
  .envelope-action-dropdown .dropdown-item.disabled
    opacity: 0.5
    cursor: not-allowed
    pointer-events: auto
.form-check
  color: #063D52
</style>
